export const brand = {
  name: 'Atlante Visivo di Chinesiologia',
  promise: '100 Mappe Visive:',
  promiseAccent: 'Quello che impari in mesi, ora puoi capirlo in ore',
  subtitle:
    'Impara ad analizzare 100 esercizi e acquisisci la sicurezza per spiegarli, riconoscere gli errori e rispondere senza bloccarti agli esami.',
}

export const heroBadges: string[] = ['Accesso immediato', 'Stampabile', 'Tuo per sempre']

export const heroCta = "Voglio l'Atlante completo"

export const heroNote = 'Accesso immediato · Pagamento unico · Garanzia di 7 giorni'

export const heroGuarantee = 'Garanzia di 7 giorni o ti rimborsiamo'

export interface Stat {
  value: string
  label: string
}

export const stats: Stat[] = [
  { value: '100', label: 'Mappe visive' },
  { value: '100', label: 'Esercizi analizzati' },
  { value: '6', label: 'Bonus inclusi' },
  { value: '3', label: 'Aree di studio' },
]

export const studyAreasLabel = 'Le 3 aree di studio'

export const studyAreas: string[] = ['Arti inferiori', 'Arti superiori', 'Core e stabilizzazione']

export interface PainGroup {
  audience: string
  points: string[]
}

export const painTitle = 'Ti riconosci in una di queste situazioni?'

export const painGroups: PainGroup[] = [
  {
    audience: 'Se studi Scienze Motorie',
    points: [
      'Leggi centinaia di pagine e dopo pochi giorni ricordi poco',
      "L'esame si avvicina e non sai da dove iniziare a ripassare",
      'Conosci la teoria, ma quando devi analizzare un esercizio ti blocchi',
    ],
  },
  {
    audience: "Se sei personal trainer o lavori nell'allenamento",
    points: [
      'Un cliente ti fa una domanda di anatomia e non sai rispondere con sicurezza',
      'Vedi un errore tecnico, ma fai fatica a spiegare perché è un errore',
      'Hai studiato anatomia, ma collegarla agli esercizi reali non è sempre immediato',
    ],
  },
]

export const painClosing = 'Non ti manca lo studio. Ti manca un sistema visivo.'

export const solutionTitle = "L'Atlante ti dà il sistema che ti mancava"

export const solutionPoints: string[] = [
  '100 mappe visive: capisci ogni esercizio in pochi minuti, senza perderti in centinaia di pagine',
  "100 analisi di esercizi reali: quelli che incontri davvero in palestra, all'università e nel lavoro",
  'Organizzato per schema di movimento: capisci la logica, non memorizzi casi isolati',
  "Muscoli, piani anatomici, esecuzione ed errori tecnici: tutto collegato direttamente all'esercizio",
  '6 bonus pratici per aiutarti a studiare, ripassare e spiegare con più sicurezza',
]

export interface Module {
  number: string
  title: string
  detail: string
  summary: string
  spine: string
}

export const modules: Module[] = [
  {
    number: '01',
    title: 'Arti Inferiori',
    detail: '40 mappe + 40 analisi',
    summary: 'Squat, stacco da terra, hip thrust, affondi, leg press e principali varianti.',
    spine: 'bg-blue-400',
  },
  {
    number: '02',
    title: 'Arti Superiori',
    detail: '40 mappe + 40 analisi',
    summary:
      'Spinte e tirate: panca, push-up, trazioni, rematori, lat machine ed esercizi di isolamento.',
    spine: 'bg-blue-600',
  },
  {
    number: '03',
    title: 'Core e Stabilizzazione',
    detail: '20 mappe + 20 analisi',
    summary: 'Plank, antirotazione, dead bug, bird dog e controllo lombo-pelvico.',
    spine: 'bg-blue-900',
  },
]

export const mapIncludes: string[] = [
  'Muscoli principali e secondari',
  'Muscoli stabilizzatori',
  'Piani anatomici e catene cinetiche',
  'Esecuzione corretta',
  'Errori più comuni e come correggerli',
  'Varianti e indicazioni pratiche',
]

export interface GalleryItem {
  title: string
  caption: string
  image: string
}

export const gallery: GalleryItem[] = [
  {
    title: 'Squat libero',
    caption:
      "Muscoli principali, stabilizzatori, piano anatomico ed errori più comuni, tutto in un'unica mappa.",
    image:
      'https://cdn.magicpatterns.com/uploads/6sNQ2x2p6PiexWnwBFcDch/image.png',
  },
  {
    title: 'Affondo bulgaro',
    caption: 'Lavoro monolaterale: cosa si stabilizza, cosa si compensa e come correggerlo.',
    image:
      'https://cdn.magicpatterns.com/uploads/1kU1kG6EajWP8Swra8rxHM/image.png',
  },
  {
    title: 'Panca inclinata',
    caption: 'Capo clavicolare del pettorale, cuffia dei rotatori e traiettoria corretta del bilanciere.',
    image:
      'https://cdn.magicpatterns.com/uploads/fZYeVgWiYYpKHmkSJJ4tVV/image.png',
  },
  {
    title: 'Crossover',
    caption: 'Adduzione orizzontale sul piano trasversale e controllo della tensione sul pettorale.',
    image:
      'https://cdn.magicpatterns.com/uploads/71Tj3CoJaiSA6dupdfnKPY/image.png',
  },
  {
    title: 'Rematore con bilanciere',
    caption: "Retrazione scapolare, catena posteriore e perché lo slancio rovina l'esercizio.",
    image:
      'https://cdn.magicpatterns.com/uploads/66sxNhtdWywJkaj5AFvr26/image.png',
  },
]

export const comparisonRows: { old: string; atlas: string }[] = [
  { old: 'Mesi di studio dispersivo', atlas: 'Un percorso visivo e organizzato' },
  { old: 'Leggi molto e ricordi poco', atlas: 'Ricordi meglio perché colleghi immagini e concetti' },
  { old: 'Memorizzi esercizi isolati', atlas: 'Capisci gli schemi di movimento' },
  {
    old: 'Conosci la teoria ma ti blocchi quando devi applicarla',
    atlas: 'Sai sempre cosa analizzare e in quale ordine',
  },
  {
    old: 'Manuali lunghi e difficili da consultare',
    atlas: '100 mappe + 100 analisi + 6 bonus in un unico sistema',
  },
]

export interface Bonus {
  tag: string
  title: string
  value: string
  benefit: string
}

export const bonusesTotalValue = '37 €'

export const bonuses: Bonus[] = [
  {
    tag: 'Bonus 01',
    title: 'Guida Anti-Blocco',
    value: '7 €',
    benefit: 'Strutture pronte per spiegare qualsiasi esercizio senza rimanere senza parole.',
  },
  {
    tag: 'Bonus 02',
    title: 'Percorso di 7 Giorni',
    value: '7 €',
    benefit: 'Cosa studiare ogni giorno e in quale ordine, senza sentirti sopraffatto.',
  },
  {
    tag: 'Bonus 03',
    title: 'Planner di Ripasso',
    value: '6 €',
    benefit: 'Piani pronti da 7 giorni, 3 giorni e 24 ore.',
  },
  {
    tag: 'Bonus 04',
    title: 'Checklist dei 60 Secondi',
    value: '6 €',
    benefit: 'Analizza qualsiasi esercizio seguendo sempre la stessa struttura.',
  },
  {
    tag: 'Bonus 05',
    title: 'Quaderno Pratico',
    value: '6 €',
    benefit: '20 esercizi reali con esempi di risposta per allenarti.',
  },
  {
    tag: 'Bonus 06',
    title: 'Dizionario Express',
    value: '5 €',
    benefit: 'Muscoli, movimenti e piani anatomici spiegati in modo semplice.',
  },
]

export interface Testimonial {
  initials: string
  quote: string
  author: string
  role: string
  city?: string
}

export const testimonials: Testimonial[] = [
  {
    initials: 'GR',
    quote:
      'Conoscevo già molti concetti, ma facevo fatica a collegarli agli esercizi. Vederli spiegati in modo visivo mi ha aiutato a capire molto meglio cosa succede durante ogni movimento.',
    author: 'Giulia R.',
    role: 'Studentessa di Scienze Motorie',
  },
  {
    initials: 'ML',
    quote:
      'Lo uso soprattutto quando voglio ripassare velocemente un esercizio. Mi piace perché trovo subito muscoli coinvolti, movimento ed errori più comuni senza dover cercare in mille appunti.',
    author: 'Marco L.',
    role: 'Personal Trainer',
  },
  {
    initials: 'EF',
    quote:
      'Avevo poco tempo per ripassare prima dell’esame e le mappe mi hanno aiutato a mettere ordine. Alcuni argomenti che sui libri mi sembravano confusi sono diventati molto più chiari.',
    author: 'Elisa F.',
    role: 'Studentessa',
  },
]

export interface FaqItem {
  question: string
  answer: string
}

export const faqs: FaqItem[] = [
  {
    question: 'Quando ricevo il materiale?',
    answer:
      "Subito dopo il pagamento riceverai l'accesso al materiale digitale. Potrai iniziare a consultarlo dal telefono, tablet o computer.",
  },
  {
    question: 'È utile se studio Scienze Motorie?',
    answer:
      "Sì. L'Atlante è pensato proprio per aiutarti a collegare anatomia, movimento ed esercizi reali attraverso un approccio visivo e pratico.",
  },
  {
    question: 'È utile anche se sono Personal Trainer?',
    answer:
      'Sì. Puoi usarlo come strumento di ripasso e consultazione per analizzare muscoli coinvolti, movimento, tecnica ed errori più comuni.',
  },
  {
    question: 'Può aiutarmi a preparare un esame?',
    answer:
      "Sì. L'Atlante ti aiuta a organizzare e visualizzare i concetti in modo più chiaro. Non sostituisce il programma del tuo corso, ma può rendere il ripasso molto più semplice e strutturato.",
  },
  {
    question: 'È un prodotto fisico?',
    answer:
      'No. È un prodotto digitale in formato PDF. Puoi consultarlo dai tuoi dispositivi oppure stamparlo.',
  },
  {
    question: 'Per quanto tempo avrò accesso?',
    answer: 'Per sempre. È un pagamento unico e non ci sono abbonamenti.',
  },
  {
    question: 'E se non fa per me?',
    answer:
      'Hai una garanzia di 7 giorni. Se il materiale non soddisfa le tue aspettative, puoi richiedere il rimborso secondo le condizioni indicate.',
  },
]

export const urgency = {
  title: 'Offerta di lancio — termina tra:',
  priceNote: "Al termine dell'offerta il prezzo aumenterà.",
  limitedNote: 'Prezzo di lancio disponibile per un periodo limitato',
  finalBadge: 'Offerta di lancio disponibile per un periodo limitato',
}

export const checkoutUrl = 'https://100mapaskinesio.impultienda.ar'

export interface Offer {
  name: string
  summary: string
  includes: string[]
  listPrice: string
  price: string
  currency: string
  discount: string
  savings: string
  cta: string
  note: string
  details: string
}

export const offer: Offer = {
  name: 'Atlante Visivo di Chinesiologia — Sistema Completo',
  summary: '100 Mappe Visive + 100 Analisi di Esercizi + 6 Bonus',
  includes: [
    '100 mappe visive',
    '100 analisi di esercizi reali',
    'Tutti e 6 i bonus — valore 37 €',
    'PDF stampabile',
    'Accesso immediato',
    'Accesso a vita',
  ],
  listPrice: '49 €',
  price: '19',
  currency: '€',
  discount: 'Offerta di lancio',
  savings: '30 €',
  cta: "Voglio l'Atlante completo",
  note: 'Pagamento unico · Nessun abbonamento',
  details: 'Accesso immediato | 100% digitale | Garanzia di 7 giorni',
}

export const heroImage =
  'https://cdn.magicpatterns.com/uploads/3tXks4zSGsi7fcjAguwFWU/mockup-italiano.png'
